
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {LineChart, Line} from 'components/Chart'
import isNumber from 'lodash/isNumber'
import NumberFormat from 'components/NumberFormat'
import DayTime from 'components/DayTime'
import ColorLegend from 'components/ColorLegend'
import propsChanged from 'utils/propsChanged'
import {TooltipTable, TooltipRow, TooltipCell} from 'components/Tooltip'

export default class DashboardChart extends React.Component {
  static propTypes = {
    data: PropTypes.array,
    today: PropTypes.instanceOf(Date),
    field: PropTypes.string,
    title: PropTypes.string,
    total: PropTypes.shape({
      currentMonth: PropTypes.number,
      prevMonth: PropTypes.number
    }),
    format: PropTypes.string,
    loading: PropTypes.bool,
    aggregated: PropTypes.bool,
    currentPeriodName: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    anotherPeriodName: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }

  static contextTypes = {
    containerWidth: PropTypes.number
  }

  constructor(props) {
    super(props)
    this.state = {
      selected: null,
      selectedLine: null,
      modeChanged: false,
      hovered: false
    }
  }

  componentWillReceiveProps(nextProps) {
    if (propsChanged(this.props, nextProps, ['aggregated'])) {
      this.setState({
        modeChanged: nextProps.aggregated
      })
    }
  }

  render() {
    const {data, today, field, loading, aggregated} = this.props
    const {selected, selectedLine, modeChanged} = this.state
    const {containerWidth} = this.context
    if (!containerWidth) return null

    const fieldKey = aggregated ? `${field}Sum` : field

    return (
      <LineChart
        data={data}
        width={containerWidth}
        height={70}
        xAxisKey='date'
        min={0}
        selected={selected}
        today={today}
        margin={{top: 0, left: 0, bottom: 0, right: 0}}
        loading={loading}
        onSelect={this.onSelect}
        flushCache={modeChanged}
        tooltip={this.renderTooltip}
        onMouseEnter={() => this.setState({
          hovered: true
        })}
        onMouseLeave={() => this.setState({
          hovered: false
        })}
      >
        <Line
          dataKey={`${fieldKey}Past`}
          color='lightest'
          strokeWidth='thin'
          selected={selectedLine === `${fieldKey}Past` || selectedLine === `${fieldKey}Regression`}
        />
        {aggregated ? <Line dataKey={`${fieldKey}Regression`} color='awesome-blue' dashed noPoints /> : null}
        <Line
          dataKey={fieldKey}
          color='awesome-blue'
          area={`${fieldKey}Past`}
          selected={selectedLine === fieldKey}
        />
      </LineChart>
    )
  }

  renderTitle() {
    const {title, currentPeriodName, anotherPeriodName} = this.props
    const {hovered} = this.state

    return (
      <div className='dashboard-chart_header'>
        <div className='dashboard-chart_title'>
          {title}
          <ColorLegend
            title={`These graphs show comparison between ${currentPeriodName} and ${anotherPeriodName}.`}
            visible={hovered}
          />
        </div>
        {this.renderTotal()}
      </div>
    )
  }

  renderTotal() {
    const {total, format, currentPeriodName, anotherPeriodName} = this.props
    const {currentMonth, prevMonth} = total || {}
    const currentMonthValue = isNumber(currentMonth) ? <NumberFormat value={currentMonth} format={format} /> : '...'
    const prevMonthValue = isNumber(prevMonth) ? <NumberFormat value={prevMonth} format={format} /> : '...'

    return (
      <div className='dashboard-chart_stats'>
        <div className='dashboard-chart_month-value'>
          {currentPeriodName}: <strong>{currentMonthValue}</strong>
        </div>
        <div className='dashboard-chart_avarage-value'>
          {anotherPeriodName}: {prevMonthValue}
        </div>
      </div>
    )
  }

  renderTooltip = data => {
    const {field, format, aggregated} = this.props
    const fieldKey = aggregated ? `${field}SumPast` : `${field}Past`

    return (
      <TooltipTable>
        {this.renderDateRow(data)}
        <TooltipRow>
          <TooltipCell><DayTime date={data.datePast} day /></TooltipCell>
          <TooltipCell color='white'><NumberFormat value={data[fieldKey]} format={format} /></TooltipCell>
        </TooltipRow>
      </TooltipTable>
    )
  }

  renderDateRow(data) {
    const {field, format, aggregated} = this.props
    const fieldKey = aggregated ? `${field}Sum` : field

    if (isNumber(data[`${field}Sum`])) {
      return (
        <TooltipRow>
          <TooltipCell><DayTime date={data.date} day /></TooltipCell>
          <TooltipCell color='white'><NumberFormat value={data[fieldKey]} format={format} /></TooltipCell>
        </TooltipRow>
      )
    } else {
      return null
    }
  }

  onSelect = (selected, selectedLine) => {
    this.setState({selected, selectedLine})
  }
}



// WEBPACK FOOTER //
// ./client/components/DashboardChart/index.js